export interface Usuario_List{
    id:number;
    nombres:string,
    apellidos: string,
    email: string,
    rol: string,
    unidad: string,
    compania: string,
    codigo_trabajador: string,
    telefono1: string,
    telefono2: string,
    estado: string,
    estado_bool : number
}

export class User_Update{
    id_user:number| undefined;
    estado: number | undefined;
}